
import React, { useState, useRef, useCallback, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button, Table } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import CurrencyInput from "react-currency-input-field";
import { FiPaperclip, FiFile, FiUploadCloud, FiArrowRight } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "./SavingsForm.module.css";
import Sidebar2 from "../../Components/SideBar2/SideBar2";
import Header2 from "../../Components/Header2/Header2";
import { FaDownload } from "react-icons/fa";
import axios from 'axios';
import { BASE_URL } from '../../Components/Api/Api';
import Swal from 'sweetalert2';
import Select from "react-select";
// import { FiFile } from "react-icons/fi";

// Max upload size in bytes (5MB)
const MAX_FILE_SIZE = 5 * 1024 * 1024;

// Recent transactions data — mapped into the table, kept as its own variable
// so it's easy to swap for an API response later.
const recentTransactions = [
  { date: "03/08/24", type: "Personal Savings", amount: "₦5,000.00", status: "Status" },
  { date: "03/98/24", type: "Personal Savings", amount: "₦5,000.00", status: "Status" },
  { date: "03/08/24", type: "Personal Savings", amount: "₦5,000.00", status: "Status" },
];

// Dropdown option lists — kept separate so <Form.Select> just maps over them.
const accountTypeOptions = ["Personal Savings", "Shares Capital", "Retirement Savings"];
const modeOfSavingsOptions = ["Bank Transfer", "USSD", "Payroll Deduction", "Card Payment"];

export default function SavingsForm() {
  // ---- Form field state (separate from file state, as requested) ----
  const [formData, setFormData] = useState({
    accountType: "",
    transactionDate: "2024-12-16",
    savingsAmount: "",
    modeOfSavings: "",
  });

  // ---- File upload state ----
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileTooLarge, setFileTooLarge] = useState(false);
  const [fileTypeError, setFileTypeError] = useState(false);
  const [savingsType, setSavingsType] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [modeOfSavings, setModeOfSavings] = useState("");
  const [reference, setReference] = useState("");
    const [loading, setLoading] = useState(true);
    const [savings, setSavings] = useState([]);
      const [paymentModes, setPaymentModes] = useState([]);
  // const [fileTooLarge, setFileTooLarge] = useState(false);

  // useRef paired with useDropzone: gives us a manual handle to the hidden
  // input so we can reset it (e.g. after a failed/oversized upload) without
  // relying on component re-mount.
  const fileInputRef = useRef(null);

  const [isSaving, setIsSaving] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();

  // if (fileTooLarge) return;

  // const errors = [];

  // if (!savingsType) errors.push("Savings account type is required");
  // if (!transactionDate) errors.push("Transaction date is required");
  // if (!amount) errors.push("Savings amount is required");
  // if (!modeOfSavings) errors.push("Mode of savings is required");

  // if (errors.length) {
  //   Swal.fire({
  //     icon: "error",
  //     title: "Missing Required Fields",
  //     html: errors.map(err => `<p>${err}</p>`).join(""),
  //     confirmButtonColor: "#000",
  //   });
  //   return;
  // }

  setIsSaving(true);

  try {
    const token = localStorage.getItem("token");
    const companyId =
      localStorage.getItem("company_id") ||
      localStorage.getItem("companyId");

    const fd = new FormData();

    fd.append("company_id", companyId);
    fd.append("account_id", savingsType.value); // type.id
    fd.append("transaction_date", transactionDate);
    fd.append("amount", amount);
    fd.append("bank", modeOfSavings);
    fd.append("description", description);
    fd.append("mode_of_savings", modeOfSavings);

    if (uploadedFile) {
      fd.append(
        "supporting_document",
        uploadedFile,
        uploadedFile.name
      );
    }

    console.log("Submitting FormData");

    for (const pair of fd.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.post(
      `${BASE_URL}/member-auth/member_make_savings`,
      fd,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      }
    );

    Swal.fire({
      icon: "success",
      title: "Success",
      text:
        response.data?.message ||
        "Savings submitted successfully.",
      confirmButtonColor: "#000",
    });

    // Reset form
    setSavingsType(null);
    setTransactionDate("");
    setAmount("");
    setModeOfSavings("");
    setUploadedFile(null);
    setFileTooLarge(false);
    setFileTypeError(false);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    // Refresh transactions
    fetchInvoices();

  } catch (error) {
    console.error(error);

    const msg =
      typeof error.response?.data?.message === "object"
        ? Object.values(error.response.data.message).flat().join(", ")
        : error.response?.data?.message || "An error occurred.";

    Swal.fire({
      icon: "error",
      title: "Save Failed",
      text: msg,
      confirmButtonColor: "#000",
    });
  } finally {
    setIsSaving(false);
  }
};

  const handleFieldChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

 const handleAmountChange = (value) => {
    setAmount(value || "");
};

  // const onDrop = useCallback((acceptedFiles, fileRejections) => {
  //   const file = acceptedFiles[0];

  //   if (file) {
  //     if (file.size > MAX_FILE_SIZE) {
  //       setFileTooLarge(true);
  //       setUploadedFile(file); // still show name, but flag it as too large
  //     } else {
  //       setFileTooLarge(false);
  //       setUploadedFile(file);
  //     }
  //     return;
  //   }

  //   // If rejected purely by dropzone's own maxSize check
  //   if (fileRejections?.length) {
  //     setFileTooLarge(true);
  //     setUploadedFile(fileRejections[0].file);
  //   }
  // }, []);

const onDrop = useCallback((acceptedFiles, fileRejections) => {

    if (acceptedFiles.length > 0) {

        setUploadedFile(acceptedFiles[0]);

        setFileTooLarge(false);

        setFileTypeError(false);

        return;

    }

    if (fileRejections.length > 0) {

        const errors = fileRejections[0].errors;

        setUploadedFile(null);

        setFileTooLarge(false);

        setFileTypeError(false);

        errors.forEach((error) => {

            if (error.code === "file-too-large") {

                setFileTooLarge(true);

            }

            if (error.code === "file-invalid-type") {

                setFileTypeError(true);

            }

        });

    }

}, []);

  // const { getRootProps, getInputProps, isDragActive } = useDropzone({
  //   onDrop,
  //   multiple: false,
  //   maxSize: MAX_FILE_SIZE,
  // });

  const {
    getRootProps,
    getInputProps,
    isDragActive
} = useDropzone({

    onDrop,

    multiple: false,

    maxSize: MAX_FILE_SIZE,

    // accept: {

    //     "application/pdf": [".pdf"],

    //     "application/msword": [".doc"],

    //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],

    //     "application/vnd.ms-excel": [".xls"],

    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],

    // }
     accept: {
    "application/pdf": [".pdf"],
    "image/jpeg": [".jpg", ".jpeg"],
  },

});

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (fileTooLarge) return; // block submit while file exceeds limit

  //   console.log("Submitting:", { ...formData, uploadedFile });
  //   // Hook this up to your API call here.
  // };


  const resetFileInput = () => {
    setUploadedFile(null);
    setFileTooLarge(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

   const fetchInvoices = async () => {
    setLoading(true);

      try {
        const token = localStorage.getItem("token");
        const companyid = localStorage.getItem("companyId");

        const res = await axios.get(
          `${BASE_URL}/member-auth/member_savings_plans?company_id=${companyid}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );
        
        // const res = await axios.get(`${BASE_URL}/member-auth/member_savings_plans`);

        // const savings = res.data?.data?.savings?.data || [];
        const savings = res.data?.data || [];
        setSavings(savings);

        // setSavings(savings);
      } catch (error) {
        console.error(error);
        setSavings([]);
      } finally {
        setLoading(false);
      }
    };

useEffect(() => {
  fetchInvoices();
}, []);

  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const token = localStorage.getItem('token');
        const companyid = localStorage.getItem("companyId");

      const res = await axios.get(
        `${BASE_URL}/member-auth/get-payment-method?company_id=${companyid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

        if (res.data && Array.isArray(res.data.data)) {
          setPaymentModes(res.data.data);
        } else {
          setPaymentModes([]);
        }
      } catch (err) {
        console.error("Error fetching payment methods:", err);
        setPaymentModes([]);
      }
    };
    fetchPaymentModes();
  }, []);

  const savingsOptions = savings.map((item) => ({
    value: item.id,
    label: item.type.product_name,
    ...item.type,
}));
  const selectedSavings = savings.find(
  (item) => Number(item.id) === Number(savingsType?.value)
);

    const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: "10px",
    fontSize: "12px",
    minHeight: 40,
    height: "auto",
    // border: "0.5px solid hsla(242, 95%, 42%, 1)",
    // "&:hover": {
    //   borderColor: "#0C06AC",
    // },
  }),
    valueContainer: (base) => ({
    ...base,
    height: 40,
    padding: "0 8px",
  }),
    input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: 40,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#15803d"
      : state.isFocused
      ? "#EBFFF3"
      : "transparent",
    color: state.isSelected ? "#fff" : "inherit",
    fontSize: "12px",
    cursor: "pointer",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6c757d",
    fontSize: "12px",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    color: "#212529",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "0.375rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    zIndex: 9999,
  }),
};

const selectedPaymentMode = paymentModes.find(
  (mode) => Number(mode.id) === Number(modeOfSavings)
);

const showSavingsNo =
  selectedPaymentMode &&
  selectedPaymentMode.name.trim().toLowerCase() !== "cash";
  return (

    <div className={styles.container}>
      {/* 1. APP SIDEBAR INTERFACE BAR LAYER */}
      <Sidebar2 />

     <main className={styles.mainContent}>
        {/* APP UPPER RESPONSIVE NAVIGATION BAR HEADER */}
        <Header2 />

    <Container fluid className={`${styles.savingsPage} py-4 px-3 px-md-4`}>
      <Row className="gy-4" md={12}>
        {/* ---------------- LEFT: FORM ---------------- */}
        <Col md={7}>
          <Card className="shadow-sm border-0 rounded-4 h-100">
            <Card.Body className="p-4">
              <h5 className="fw-bold mb-1">Memeber Savings</h5>
              <p className="text-muted small mb-4">
                Provide the details of the savings you are applying for
              </p>

              <Form 
              // onSubmit={handleSubmit}
              >
                {/* Row 1: Account Type + Transaction Date */}
                <Row className="mb-3 gy-3">
                  <Col md={6}>
                    <Form.Group controlId="accountType">
                      <Form.Label className="fw-semibold small">
                        Savings Account Type <span className="text-danger">*</span>
                      </Form.Label>
                      {/* <Form.Select
                        value={savingsType}
                        onChange={(e) => setSavingsType(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          Select Account Type
                        </option>
                        {accountTypeOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </Form.Select> */}
                       <Select
                      options={savingsOptions}
                      value={savingsType}
                      onChange={(selected) => setSavingsType(selected)}
                      placeholder="Select Account Type"
                      isLoading={loading}
                      styles={selectStyles}
                  />
                    </Form.Group>
                                         {selectedSavings && (
                <div
                  className="mt-2 p-2"
                  style={{
                    background: "#EBFFF3",
                    border: "1px solid #16a34a",
                    fontSize: "12px",
                    width: "fit-content",
                    borderRadius: "12px",
                    display: "flex",
                    gap: "5px",
                    alignItems: "center"
                  }}
                >
                  <small className="text-muted d-block">
                    Available Balance:
                  </small>

                  <strong className="text-success">
                    ₦
                    {Number(selectedSavings.balance || 0).toLocaleString("en-NG", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </strong>
                </div>
    )}
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="transactionDate">
                      <Form.Label className="fw-semibold small">
                        Transaction Date <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="date"
                        value={transactionDate}
                        onChange={(e) => setTransactionDate(e.target.value)}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* Row 2: Savings Amount + Mode of Savings */}
                <Row className="mb-3 gy-3">
                  <Col md={6}>
                    <Form.Group controlId="savingsAmount">
                      <Form.Label className="fw-semibold small">
                        Savings Amount <span className="text-danger">*</span>
                      </Form.Label>
                      <div className={styles.currencyInputWrapper}>
                        <span className={styles.currencySymbol}>₦</span>
                        <CurrencyInput
                           id="savingsAmount"
                          name="savingsAmount"
                          className={`form-control ${styles.currencyInput}`}
                          placeholder="Enter Amount"
                          value={amount}
                          onValueChange={handleAmountChange}
                          prefix=""
                          decimalsLimit={2}
                          groupSeparator=","
                          decimalSeparator="."
                          allowDecimals
                        />
                      </div>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group controlId="modeOfSavings">
                      <Form.Label className="fw-semibold small">
                        Mode of Savings <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Select
                        value={modeOfSavings}
                        onChange={(e) => setModeOfSavings(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          Select Savings
                        </option>
                         {paymentModes.map((mode) => (
                            <option
                              key={mode.id}
                              value={mode.id}
                            >
                              {mode.name.trim()}
                            </option>
                          ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mb-3 gy-3">
                <Col md={12}>
                  <Form.Group controlId="description">
                    <Form.Label className="fw-semibold small">
                      Description <span className="text-danger">*</span>
                    </Form.Label>

                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Enter description..."
                      required
                      style={{ resize: "vertical" }} // allows user to expand vertically
                    />
                  </Form.Group>
                </Col>
              </Row>

                <Row className="mb-3 gy-3">
                                   {showSavingsNo && (
  <Col md={12}>
    <Form.Group controlId="reference">
      <Form.Label className="fw-semibold small">
        Reference/Savings No.
      </Form.Label>
      <Form.Control
        type="text"
        value={reference}
        onChange={(e) => setReference(e.target.value)}
        placeholder="Enter Savings No."
      />
    </Form.Group>
  </Col>
)}
                </Row>

                {/* Small paperclip attachment row (as shown in the design) */}
                {/* <Row className="mb-2">
                  <Col md={12}>
                    <Form.Label className="fw-semibold small d-block">
                      Attachment (Receipt/Proof) <span className="text-danger">*</span>
                    </Form.Label>
                    <div className={styles.attachmentIcon}>
                      <FiPaperclip size={18} />
                    </div>
                  </Col>
                </Row> */}

                {/* Row 3: Full-width dropzone file upload */}
               <Row className="mb-2">
                  <Col md={12}>
                    <Form.Label className="fw-semibold small d-block">
                      Attachment (Receipt/Proof) <span className="text-danger">*</span>
                    </Form.Label>

                    <div
                      {...getRootProps()}
                      className={`${styles.dropzone} ${styles.uploadX}`} // reuse your existing classes
                      style={{
                        border: isDragActive ? "2px dashed #16a34a" : undefined,
                        cursor: "pointer",
                      }}
                    >
                      <input {...getInputProps()} />

                      <div className={styles.dropzoneContent}>
                        <FaDownload size={20} className=" text-secondary" />

                        <div className="fw-semibold text-center">
                          {isDragActive
                            ? "Drop File Here"
                            : uploadedFile
                            ? uploadedFile.name
                            : "Drag & Drop or Click to choose file"}
                        </div>

                        {!uploadedFile && (
                          <FiFile
                              size={22}
                              className="text-secondary"
                          />

                      )}

                        {/* {uploadedFile && (
                          <small className="text-muted mt-1">
                            {uploadedFile.name}
                          </small>
                        )} */}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-2">
                      {/* <small className={fileTooLarge ? "text-danger fw-semibold" : "text-muted"}>
                        Max size: 5MB
                      </small> */}
                      <div>

                      {fileTooLarge && (

                          <small className="text-danger fw-semibold">

                              File exceeds maximum size of 5MB

                          </small>

                      )}

                      {/* {fileTypeError && (

                          <small className="text-danger fw-semibold">

                              Only PDF, Word or Excel files are allowed.

                          </small>

                      )}

                      {!fileTooLarge && !fileTypeError && (

                          <small className="text-muted">

                              Accepted: PDF, DOC, DOCX, XLS, XLSX (Max 5MB)

                          </small>

                      )} */}

                      {fileTypeError && (
                        <small className="text-danger fw-semibold">
                            Only PDF, JPG or JPEG files are allowed.
                        </small>
                    )}

                    {!fileTooLarge && !fileTypeError && (
                        <small className="text-muted">
                            Accepted: PDF, JPG, JPEG (Max 5MB)
                        </small>
                    )}

                  </div>

                      {uploadedFile && (
                        <small
                          role="button"
                          className="text-decoration-underline text-secondary"
                          onClick={resetFileInput}
                        >
                          Remove
                        </small>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md={12} className="d-flex justify-content-end mt-3">
                    <Button
                      type="submit"
                      className={`${styles.submitBtn} d-flex align-items-center gap-2`}
                      // disabled={fileTooLarge}
                      onClick={handleSubmit}
                    >
                       {isSaving ? "Submitting..." : "Submit"} 
                      <FiArrowRight size={16} />
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        {/* ---------------- RIGHT: TRANSACTIONS + PROGRESS ---------------- */}
        <Col md={5}>
          <Row className="gy-4">
            <Col md={12}>
              <Card className="shadow-sm border-0 rounded-4">
                <Card.Body className="p-4">
                  <h6 className="fw-bold mb-1">Recent Savings Transactions</h6>
                  <p className="text-muted small mb-3">Last three savings transactions</p>

                  <Table
                    borderless
                    responsive
                    className={`mb-2 ${styles.recentTransactionsTable}`}
                  >
                    <thead>
                      <tr className="text-muted small">
                        <th>Date</th>
                        <th>Type</th>
                        <th>Amount</th>
                        {/* <th>Status</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {recentTransactions.map((tx, idx) => (
                        <tr key={idx}>
                          <td className="small">{tx.date}</td>
                          <td className="small">{tx.type}</td>
                          <td className="small">{tx.amount}</td>
                          {/* <td>
                            <span className={styles.statusPill}>{tx.status}</span>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <a href="#" className={styles.viewDetailsLink}>
                    View Details <FiArrowRight size={14} />
                  </a>
                </Card.Body>
              </Card>
            </Col>

            {/* <Col md={12}>
              <Card className="shadow-sm border-0 rounded-4">
                <Card.Body className="p-4">
                  <h6 className="fw-bold mb-1">Savings Goal Progress</h6>
                  <p className="text-muted small mb-3">
                    Savings goal travel to soaplete hmate set goal
                  </p>

                  <div className={`${styles.progressTrack} mb-2`}>
                    <div
                      className={styles.progressFill}
                      style={{ width: `${(1200000 / 5000000) * 100}%` }}
                    />
                  </div>

                  <p className="fw-bold small mb-3">
                    ₦1,200,000.00 / ₦5,000,000.00
                  </p>

                  <a href="#" className={styles.viewDetailsLink}>
                    View Details <FiArrowRight size={14} />
                  </a>
                </Card.Body>
              </Card>
            </Col> */}
          </Row>
        </Col>
      </Row>
    </Container>
    </main>
    </div>
  );
}

